import { render, staticRenderFns } from "./AdminMetrics.vue?vue&type=template&id=2a6d42a3"
import script from "./AdminMetrics.vue?vue&type=script&lang=ts"
export * from "./AdminMetrics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports